export default __webpack_public_path__ + "static/media/complementos_2.3bc4900d.jpg";